import { EOrganization, ESnapshotExists } from 'lib/types';
import React, { useState } from 'react';
import { getNewspaperLogo } from '../helpers/newspapers';

type NewspaperOrgImageProps = {
  newspaper: ESnapshotExists<EOrganization>;
  className?: string;
};

function NewspaperOrgImage({ newspaper, className }: NewspaperOrgImageProps) {
  const [loading, setLoading] = useState(true);

  const logoPath = getNewspaperLogo(newspaper);

  return (
    <>
      {(loading || !logoPath) && <span>{newspaper.data().name}</span>}
      {logoPath && (
        <img
          className={className}
          src={logoPath}
          alt={newspaper.data().name}
          onLoad={() => setLoading(false)}
        />
      )}
    </>
  );
}

export default NewspaperOrgImage;
